import * as constants from './Constants'
import Config from './Infra/configs'

const config = new Config({ constants })
const script = document.createElement('script')
script.type = 'text/javascript'
script.src = config.WEB_CHAT
document.body.appendChild(script)
